import { Button } from "@/components/ui/button";
import { Download, Check, Smartphone } from "lucide-react";
import { usePWAInstall } from "@/hooks/usePWAInstall";

interface PWAInstallButtonProps {
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg";
  className?: string;
  showOnlyWhenInstallable?: boolean;
}

export function PWAInstallButton({
  variant = "outline",
  size = "default",
  className,
  showOnlyWhenInstallable = true,
}: PWAInstallButtonProps) {
  const { isInstallable, isInstalled, promptInstall } = usePWAInstall();

  if (isInstalled) {
    return (
      <Button variant={variant} size={size} className={className} disabled>
        <Check className="w-4 h-4 mr-2" />
        Installed
      </Button>
    );
  }

  if (showOnlyWhenInstallable && !isInstallable) {
    return null;
  }

  if (!isInstallable) {
    return (
      <Button variant={variant} size={size} className={className} disabled>
        <Smartphone className="w-4 h-4 mr-2" />
        Open in browser to install
      </Button>
    );
  }

  return (
    <Button variant={variant} size={size} className={className} onClick={promptInstall}>
      <Download className="w-4 h-4 mr-2" />
      Install App
    </Button>
  );
}
